import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import './css/contactClient.css';
import { SendEmailClient } from '../../Api/ClientApi/ContactClientApi';

const Contact = () => {

    const [sujet, setSujet] = useState([]);
    const [contenu, setContenu] = useState([]);
    const [loading, setLoading] = useState(false);

    let location = useLocation();

    const client = useSelector((state) => state.client);


    const handleAddContact = (e) => {
        e.preventDefault();
        setLoading(true);
        const data = { nom: client.nom, prenom: client.prenom, email: client.email, sujet: sujet, contenu: contenu };
        SendEmailClient(data).then(function (response) {
            console.log(response);
            if (response.data.title === "success") {
                toast.success(response.data.message);
            }
        }).catch(function (error) {
            console.log(error);
            if (error) {
                toast.error(error.response.data?.message);
            }
        }).finally(function () {
            setLoading(false);
            setSujet('');
            setContenu('');
        });

    }


    return (
        <div>
            <Helmet>
                <title>Contact </title>
                <meta name='description' content='Contact' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='contact_client'>
                <div className='container'>
                    <div className='bloc_contact'>
                        <div className='titre'>
                            <h1><i className='fa fa-phone'></i>Contactez-nous</h1>
                        </div>
                        <form onSubmit={handleAddContact}>
                            <div className='liste_donner'>
                                <h2>Remplissez le formulaire</h2>
                                <input type='text' className='form-control' value={sujet} required onChange={(e) => setSujet(e.target.value)} placeholder='Sujet ...' />
                                <textarea className='form-control' value={contenu} required onChange={(e) => setContenu(e.target.value)} placeholder='Contenu ...' cols='30' rows='8'></textarea>
                            </div>
                            {loading ?
                                <div className='d-flex justify-content-center'>
                                    <Button className='btn btn_confirmContact' disabled>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            variant="info"
                                            className="spiner"
                                        />
                                        Chargement...
                                    </Button>
                                </div> :
                                <div className='d-flex justify-content-center'>
                                    <button type="submit" className='btn btn_send_contact'>Envoyer la demande</button>
                                </div>}

                        </form>
                        <p className="version">Version 1</p>
                    </div>
                </div>
                
            </div>
        </div>
    )
}

export default Contact